import React, {Component} from "react";
import "./UserHeader.css";
import DateText from "../../common/DateText/DateText";

class UserHeader extends Component {
  render() {
    return (
      <div className="user-header">
        <div className="row">
            <div className="col-md-6">
                <div className="row details-row">
                    <div className="col-md-3 details-label">Email</div>
                    <div className="col-md-9">{this.props.user.email}</div>
                </div>
                <div className="row details-row">
                    <div className="col-md-3 details-label">Status</div>
                    <div className="col-md-9">{this.props.user.isActive ? "Active" : "Inactive"}</div>
                </div>
                <div className="row details-row">
                    <div className="col-md-3 details-label">Email Verified</div>
                    <div className="col-md-9">{this.props.user.emailVerified ? "Yes" : "No"}</div>
                </div>
                <div className="row details-row">
                    <div className="col-md-3 details-label">DTN Employee</div>
                    <div className="col-md-9">{this.props.user.isDtnEmployee ? "Yes" : "No"}</div>
                </div>
            </div>
            <div className="col-md-6">
                <div className="row details-row">
                    <div className="col-md-5 details-label">Created</div>
                    <div className="col-md-7"><DateText date={this.props.user.createdAt}/></div>
                </div>
                <div className="row details-row">
                    <div className="col-md-5 details-label">Updated</div>
                    <div className="col-md-7"><DateText date={this.props.user.updatedAt}/></div>
                </div>
                <div className="row details-row">
                    <div className="col-md-5 details-label">Password reset</div>
                    <div className="col-md-7"><DateText date={this.props.user.lastPasswordReset}/></div>
                </div>
                <div className="row details-row">
                    <div className="col-md-5 details-label">Last IP</div>
                    <div className="col-md-7">{this.props.user.lastIp ? this.props.user.lastIp : "-"}</div>
                </div>
                <div className="row details-row">
                    <div className="col-md-5 details-label">Last login</div>
                    <div className="col-md-7 relative-time"><DateText date={this.props.user.lastLogin}
                                                                      relativeTime="true"/>
                    </div>
                </div>
                <div className="row details-row">
                    <div className="col-md-5 details-label">Total logins</div>
                    <div className="col-md-7">{this.props.user.loginsCount}</div>
                </div>
            </div>
        </div>
      </div>
    );
  }
}

export default UserHeader;



// WEBPACK FOOTER //
// ./src/user-profile/components/UserHeader.js